import { createSelector } from 'reselect'
import { StatisticsRootState } from '../statisticsRoot.reducer'

export const getTheme = createSelector(
  (state: StatisticsRootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: StatisticsRootState) => state.commonStore.user,
  (state) => state,
)

export const getLicensePermissions = createSelector(
  (state: StatisticsRootState) => state.commonStore.licensePermissions,
  (state) => state,
)

export const namedRequestInProgress = createSelector(
  [
    (state: StatisticsRootState) => state.commonStore.requests,
    (state: StatisticsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestStatus = createSelector(
  [
    (state: StatisticsRootState) => state.commonStore.requests,
    (state: StatisticsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)?.status
  },
)

export const namedRequestData = createSelector(
  [
    (state: StatisticsRootState) => state.commonStore.requests,
    (state: StatisticsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
